// src/features/account/useAccountSwal.js
import { useMemo } from "react";
import Swal from "../../utils/apparifySwal";

export function useAccountSwal() {
  const swalBase = useMemo(() => ({}), []);

  const toast = useMemo(
    () =>
      Swal.mixin({
        toast: true,
        position: "bottom",
        showConfirmButton: false,
        timer: 1100,
        timerProgressBar: true,
      }),
    []
  );

  return { swalBase, toast };
}
